/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { QueryClient, UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import fetch from '../../client.ts';
import {
  submitDipApplicationMutationRequestSchema,
  submitDipApplicationMutationResponseSchema,
} from '../schemas/submitDipApplicationSchema.ts';
import type {
  SubmitDipApplication400,
  SubmitDipApplication404,
  SubmitDipApplication500,
  SubmitDipApplicationMutationRequest,
  SubmitDipApplicationMutationResponse,
  SubmitDipApplicationPathParams,
} from '../types/SubmitDipApplication.ts';

export const submitDipApplicationMutationKey = () =>
  [{ url: '/user/application/:agreementReference/:applicationId' }] as const;

export type SubmitDipApplicationMutationKey = ReturnType<typeof submitDipApplicationMutationKey>;

/**
 * @description User API to submit the DIP Application form
 * @summary Submit DIP Application
 * {@link /user/application/:agreementReference/:applicationId}
 */
export async function submitDipApplication(
  {
    agreementReference,
    applicationId,
    data,
  }: {
    agreementReference: SubmitDipApplicationPathParams['agreementReference'];
    applicationId: SubmitDipApplicationPathParams['applicationId'];
    data: SubmitDipApplicationMutationRequest;
  },
  config: Partial<RequestConfig<SubmitDipApplicationMutationRequest>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = submitDipApplicationMutationRequestSchema.parse(data);

  const res = await request<
    SubmitDipApplicationMutationResponse,
    ResponseErrorConfig<SubmitDipApplication400 | SubmitDipApplication404 | SubmitDipApplication500>,
    SubmitDipApplicationMutationRequest
  >({
    method: 'PUT',
    url: `/user/application/${agreementReference}/${applicationId}`,
    data: requestData,
    ...requestConfig,
  });
  return submitDipApplicationMutationResponseSchema.parse(res.data);
}

/**
 * @description User API to submit the DIP Application form
 * @summary Submit DIP Application
 * {@link /user/application/:agreementReference/:applicationId}
 */
export function useSubmitDipApplication<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SubmitDipApplicationMutationResponse,
      ResponseErrorConfig<SubmitDipApplication400 | SubmitDipApplication404 | SubmitDipApplication500>,
      {
        agreementReference: SubmitDipApplicationPathParams['agreementReference'];
        applicationId: SubmitDipApplicationPathParams['applicationId'];
        data: SubmitDipApplicationMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<SubmitDipApplicationMutationRequest>> & { client?: typeof fetch };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? submitDipApplicationMutationKey();

  return useMutation<
    SubmitDipApplicationMutationResponse,
    ResponseErrorConfig<SubmitDipApplication400 | SubmitDipApplication404 | SubmitDipApplication500>,
    {
      agreementReference: SubmitDipApplicationPathParams['agreementReference'];
      applicationId: SubmitDipApplicationPathParams['applicationId'];
      data: SubmitDipApplicationMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ agreementReference, applicationId, data }) => {
        return submitDipApplication({ agreementReference, applicationId, data }, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  );
}
